export default class subscribe {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.email = rawData.email;
      this.creationDate = rawData.creationDate;
    }
  }